import InstallPWA from '@components/ui/pwa/install-pwa';
export default InstallPWA;
